import { useEffect, useState } from "react";
import { PORTFOLIO_TEMPLATES_PATH } from "lib/constants";
import { getURLToFetch } from "lib/utils";
import { PortfolioTemplate, PortfolioResponse } from "./types";

const usePortfolioTemplates = () => {
  const [portfoliosResponse, setPortfoliosResponse] = useState<PortfolioResponse>({
    error: false,
    loading: true,
    portfolios: [],
  });

  useEffect(() => {
    fetch(getURLToFetch(PORTFOLIO_TEMPLATES_PATH), {
      method: "POST",
    })
      .then((res) => res.json())
      .then((portfolioTemplates: PortfolioTemplate[]) => {
        setPortfoliosResponse({
          ...portfoliosResponse,
          loading: false,
          portfolios: portfolioTemplates,
        });
      })
      .catch((error) => {
        setPortfoliosResponse({ ...portfoliosResponse, error, loading: false });
      });
  }, []);

  return { ...portfoliosResponse };
};

export { usePortfolioTemplates };
